module.exports = __webpack_public_path__ + "img/grate-droplet.94e51fb6.svg";